module.exports = __webpack_public_path__ + "908e4d2e/img/saly-icon.39e12342.jpg";